import PoolRanking from "../PoolRanking/PoolRanking";
import PoolHeader from "../../../../uikit/PoolHeader/PoolHeader";
import { PoolRankingType } from "../../../../types";
import { classNames } from "../../../../utils";

interface PoolRankingGridProps {
  selectedPool: string | undefined;
  pools?: PoolRankingType[];
}

const PoolRankingGrid = ({ selectedPool, pools }: PoolRankingGridProps) => {
  const poolSelected = pools?.find((pool) => pool.name === selectedPool);
  const renderPool = (pool: PoolRankingType) => {
    if (!pool) {
      return null;
    }

    return (
      <div key={pool.id} className="group relative">
        <PoolHeader>{pool.name}</PoolHeader>
        <PoolRanking pool={pool} />
      </div>
    );
  };
  return (
    <div
      className={classNames(
        "grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-2 xl:gap-x-2",
        !poolSelected
          ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:gap-x-2"
          : ""
      )}
    >
      {poolSelected ? renderPool(poolSelected) : pools?.map(renderPool)}
    </div>
  );
};

export default PoolRankingGrid;
